// Namespace "public" — fragment "breakdown" (BUG-048 / BUG-054).
//
// WHAT A BUYER IS TOLD A THING COSTS, BEFORE THEY PAY. Every one of these rows renders a
// number the SERVER computed (GET /api/public/checkout-breakdown → the same
// `promos.resolve_discount` and `platform_helpers.compute_tax_split` the charge runs
// through). Nothing here is a claim this page worked out for itself, which is why the
// labels name the parts ("GST (5 %)") instead of summarising them ("taxes included").
//
// `breakdown.unavailable` is the honest degraded state and is NOT decoration: when the
// quote cannot be read, the page knows the item price and does NOT know the total. Saying
// so is the difference between a page that is quiet about tax and a page that presents a
// pre-tax figure as the amount payable — the defect BUG-054 reported.
//
// `breakdown.taxLine` carries the percent as a slot rather than a formatted string
// because the space before "%" is a locale rule (French inserts one, English does not),
// and it belongs in the copy, not in the component.
//
// `purchase.title` heads the panel that BUG-049 introduced (components/checkout/
// PurchasePanel.jsx): the step where the buyer has chosen an item and is offered the
// instruments for it. The pay button reuses each page's own CTA wording, so no second
// "Buy"/"Enroll" string is invented here.
export default {
  fr: {
    "purchase.title": "Votre achat",
    "breakdown.item": "Prix de l'article",
    "breakdown.discount": "Remise · {code}",
    "breakdown.taxLine": "{name} ({rate} %)",
    "breakdown.subtotal": "Sous-total",
    "breakdown.total": "Total à payer",
    "breakdown.taxIncludedNote": "Les prix affichés incluent les taxes.",
    "breakdown.unavailable":
      "Le total avec les taxes s'affiche à l'étape de paiement.",
  },
  en: {
    "purchase.title": "Your purchase",
    "breakdown.item": "Item price",
    "breakdown.discount": "Discount · {code}",
    "breakdown.taxLine": "{name} ({rate}%)",
    "breakdown.subtotal": "Subtotal",
    "breakdown.total": "Total to pay",
    "breakdown.taxIncludedNote": "Displayed prices include tax.",
    "breakdown.unavailable":
      "The total including tax is shown at the payment step.",
  },
  es: {
    "purchase.title": "Tu compra",
    "breakdown.item": "Precio del artículo",
    "breakdown.discount": "Descuento · {code}",
    "breakdown.taxLine": "{name} ({rate} %)",
    "breakdown.subtotal": "Subtotal",
    "breakdown.total": "Total a pagar",
    "breakdown.taxIncludedNote": "Los precios mostrados incluyen impuestos.",
    "breakdown.unavailable":
      "El total con impuestos se muestra en el paso de pago.",
  },
};
